import React, {Component} from "react"
import {Route, Redirect} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"
import NotFound from "../NotFound"
import Maintenance from "../Maintenance"
import Welcome from "./welcome"
import Ghost from "../../containers/Ghost"
import ContactPreferencesExternal from "../ContactPreferencesExternal"
import ContactPreferencesSuccessExternal from "../ContactPreferencesExternal/Success"
import WorkOSIntegrationsLink from "../../containers/WorkOSIntegrationsLink"

interface Props {
  path: string
}

export default class platform extends Component<Props> {
  render() {
    const {path} = this.props

    return (
      <Route path={path}>
        <>
          <Route path="/welcome" component={Welcome} />
          <Route noauth path="/internal/ghost" component={Ghost} />
          <NestedRoute noauth match={path} path="maintenance" component={Maintenance} title="Perkbox under maintenance" />
          <Route
            noauth
            path="/workOS-integrations-link"
            title="WorkOS Integration Link"
            component={WorkOSIntegrationsLink} />
          <Route path="NotFound" component={NotFound} />
          <Route exact path="/signup" render={() => <Redirect to="/welcome/signup" />} />
          <NestedRoute
            noauth
            exact
            match={path}
            path="marketing/prefs/:userId/:signature"
            title="Contact Preferences"
            useGrid={false}
            component={ContactPreferencesExternal} />
          <NestedRoute
            noauth
            match={path}
            path="marketing/prefs/success"
            title="Contact Preferences"
            useGrid={false}
            component={ContactPreferencesSuccessExternal} />
        </>
      </Route>
    )
  }
}
